import options from './content.component';

export default {
    selector: 'dtLayoutContent',
    options
};



// WEBPACK FOOTER //
// ./app/common/content/index.js